import { render, staticRenderFns } from "./input-default-value.vue?vue&type=template&id=081f4540&"
import script from "./input-default-value.vue?vue&type=script&lang=js&"
export * from "./input-default-value.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports